import { Injectable } from '@angular/core';
import { ReportesRequestService } from './request/reportes-request.service';

@Injectable({
  providedIn: 'root'
})
export class ServicioLaboratorioService {

  constructor( private requestUrl: ReportesRequestService ) { }

  async getSedes( objetoConsolidado: ConsolidadoLaboratorioEntity){
    try {
      let response = await this.requestUrl.getFilterRequest(
        'laboratorio/sedes',
        [objetoConsolidado.codigo]
      );

      return response;

    } catch (e) {
      console.log(`ServicioLaboratorioService.getSedes() ${e}`);
    }

    return null;
  }

  async getSedesPuntosAtencion( objetoCita : CitaLaboratorioEntity ) {
    try{
      let response = await this.requestUrl.getFilterRequest(
        'laboratorio/sedePuntosAtencion',
        [objetoCita.codigo]
      );
      return response;
    } catch(e) {
      console.log(`ServicioLaboratorioService.getSedesPuntosAtencion() ${e} `);
    }
    return null;
  }

  async getConsolidadoData(objetoConsolidado: ConsolidadoLaboratorioEntity) {
    try {
      const response = await this.requestUrl.getRequest(
        'laboratorio/consolidado-laboratorios',
        [
          objetoConsolidado.codigo,
          {
            'fechaInicial' : objetoConsolidado.fechaInicial,
            'fechaFinal' : objetoConsolidado.fechaFinal,
            'sede' : objetoConsolidado.sede
          }
        ]);
        return response;
    } catch (e) {
      console.log(`ServicioLaboratorioService.getConsolidadoData() ${e}`);
    }
  }

  async getCitaData( objetoCita: CitaLaboratorioEntity ) {
    try {
      const response = await this.requestUrl.getRequest(
        'laboratorio/citas-laboratorio',
        [
          objetoCita.codigo,
          {
            'fechaInicial' : objetoCita.fechaInicial,
            'fechaFinal' : objetoCita.fechaFinal,
            'spa' : objetoCita.sedePuntoAtencion
          }
        ]);
      return response;
    } catch (e) {
      console.error(`ServicioLaboratorioService.getCitaData() ${e}`);
    }
  }

  // Inconformidad Agenda Header
  async getSedesPuntosAtencionInconformidad( objetoInconformidad: InconformidadLaboratorioEntity) {
    try {
      const response = await this.requestUrl.getFilterRequest(
        'laboratorio/sedePuntosAtencion',
        [objetoInconformidad.codigo]
      );
      return response;
    } catch (e) {
      console.log(`ServicioLaboratorioService.getSedesPuntosAtencionInconformidad() ${e} `);
    }
    return null;
  }

  async getInconformidadesData( objetoInconformidad: InconformidadLaboratorioEntity) {
    try {
      const response = await this.requestUrl.getRequest(
        'laboratorio/inconformidad-agenda',
        [
          objetoInconformidad.codigo,
          {
            'fechaInicial' : objetoInconformidad.fechaInicial,
            'fechaFinal' : objetoInconformidad.fechaFinal,
            'spa' : objetoInconformidad.sedePuntoAtencion
          }
        ]);
      return response;
    } catch (e) {
      console.error(`ServicioLaboratorioService.getCitaData() ${e}`);
    }
  }

  // Orden Medica Sin Agenda
  async getSedesOrdenesMedicasSinAgenda( objetoOrdenAgenda: OrdenMedicaSinAgendaEntity) {
    try {
      const response = await this.requestUrl.getFilterRequest(
        'laboratorio/sedes',
        [objetoOrdenAgenda.codigo]
      );
      return response;
    } catch (e) {
      console.log(`ServicioLaboratorioService.getSedesOrdenesMedicasSinAgenda() ${e}`);
    }

    return null;
  }

  async getOrdenesMedicaSinAgenda( objetoOrdenAgenda: OrdenMedicaSinAgendaEntity ) {
    try {
      const response = await this.requestUrl.getRequest(
        'laboratorio/ordenes-sin-agenda',
        [
          objetoOrdenAgenda.codigo,
          {
            'fechaInicial' : objetoOrdenAgenda.fechaInicial,
            'fechaFinal' : objetoOrdenAgenda.fechaFinal,
            'sede' : objetoOrdenAgenda.sede
          }
        ]);
      return response;
    } catch (e) {
      console.error(`ServicioLaboratorioService.getInconformidadesData() ${e}`);
    }
  }
}


export interface Sedes {
  unco: number;
  descripcionCorta: string;
  descripcion: string;
}

export interface PuntoAtencion {
  unco: number;
  descripcion: string;
}

export interface SedePuntoAtencion {
  unco: number;
  sede: Sedes;
  puntoAtencion: PuntoAtencion;
}

export interface ConsolidadoLaboratorioEntity {
  codigo: string;
  fechaInicial: number;
  fechaFinal: number;
  sede: number;
}

export interface ConsolidadoLaboratorioBodyEntity {
  numeroOrden: string;
  identificacionPaciente: string;
  nombresPaciente: string;
  apellidosPaciente: string;
  codigoServicio: string;
  servicio: string;
  estadoSolicitud: number;
  fechaSolicitud: number;
  fechaEntrega: number;
  sede: string;
  usuarioCreacion: string;
}

export interface ConsolidadoLaboratorioExcelEntity {
  sede: string;
  orden: string;
  identificacion: string;
  afiliado: string;
  codigo: string;
  laboratorio: string;
  estado: string;
  fechaSolicitud: Date;
  fechaEntrega: Date;
  usuarioCreacion: string;
}

export interface CitaLaboratorioEntity {
  codigo: string;
  fechaInicial: number;
  fechaFinal: number;
  sedePuntoAtencion: number;
  descripcionSedePuntoAtencion: string;
}

export interface CitaLaboratorioBodyEntity {
  unco: number;
  sedePuntoAtencion: string;
  periodoInicial: number;
  periodoFinal: number;
  identificacion: string;
  primerNombre: string;
  segundoNombre: string;
  primerApellido: string;
  segundoApellido: string;
  telefono: string;
  correo: string;
  empresa: string;
  servicio: string;
}

export interface CitaLaboratorioExcelEntity {
  puntoAtencion: string;
  periodoInicial: string;
  identificacion: string;
  primerNombre: string;
  segundoNombre: string;
  primerApellido: string;
  segundoApellido: string;
  telefono: string;
  correo: string;
  empresa: string;
  servicio: string;
}

export interface InconformidadLaboratorioEntity {
  codigo: string;
  fechaInicial: number;
  fechaFinal: number;
  sedePuntoAtencion: number;
  descripcionSedePuntoAtencion: string;
  activaJustificacion: boolean;
}

export interface InconformidadLaboratorioBodyEntity {
  unco: number;
  sedePuntoAtencion: string;
  fecha: number;
  numeroIdentificacion: string;
  primerNombre: string;
  segundoNombre: string;
  primerApellido: string;
  segundoApellido: string;
  telefono: string;
  usuario: string;
  justificacion: string;
}

export interface OrdenMedicaSinAgendaEntity {
  codigo: string;
  fechaInicial: number;
  fechaFinal: number;
  sede: number;
  descripcionSede: string;
}

export interface OrdenMedicaSinAgendaBodyEntity {
  unco: number;
  numeroOrden: string;
  sede: string;
  uncoProfesional: number;
  codigoDocumento: string;
  numeroDocumento: string;
  fechaAtencion: number;
  tipoOrigen: string;
  nombresProfesional: string;
  apellidosProfesional: string;
  primerNombre: string;
  segundoNombre: string;
  primerApellido: string;
  segundoApellido: string;
  telefono: string;
  cantidad ?: number;
}
